import axios from "axios";
import cookie from "./cookie";

/**
 * functions
 */
export const Http = axios.create({
  timeout: 45000,
  headers: {
    "X-Requested-With": "XMLHttpRequest",
    "Content-Type": "application/json",
    Accept: "application/json"
  }
});

Http.interceptors.request.use((config) => {
  if (!config?.unauthenticated) {
    const token = cookie.get("token");

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
  }

  return config;
});

Http.interceptors.response.use(
  (response) => response?.data,
  (error) => {
    if (error.response?.status) {
      if (error.response.status === 401) {
        cookie.remove("token");
      }

      return Promise.reject(
        error.response.data.errors ||
          error.response.data.responsemessage ||
          error.response.data.message
      );
    }

    return Promise.reject(error);
  }
);

export default Http;
